<template>
  <div class="overflow-x-auto">
    <table class="border-static-default-low min-w-full border-collapse border">
      <thead v-if="block.headers" class="bg-static-default-min">
        <tr>
          <th
            v-for="(header, index) in block.headers"
            :key="index"
            class="border-static-default-low border px-4 py-2 text-left"
          >
            <TextBlock :block="{ type: 'text', content: header.content }" />
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(row, rowIndex) in block.rows"
          :key="rowIndex"
          class="hover:bg-static-default-min"
        >
          <td
            v-for="(cell, cellIndex) in row.cells"
            :key="cellIndex"
            class="border-static-default-low border px-4 py-2"
          >
            <TextBlock :block="{ type: 'text', content: cell.content }" />
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script setup lang="ts">
import type { TableBlock } from '@backmarket/catalog-shared-artifacts'

import TextBlock from './TextBlock.vue'

defineProps<{
  block: TableBlock
}>()
</script>
